module.exports = __webpack_public_path__ + "static/media/female2.212164f9.png";